import React, { useEffect, useState } from "react";
import "./Wishlist.css";
import Common_breadcrumb from "../common-components/common-breadcrumb/Common_breadcrumb";
import { Form } from "react-bootstrap";
import Blue_Round_Btn from "../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Success_Modal from "../common-components/common-modals/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllWishlist,
  postWishlist,
} from "../../features/wishlist/wishlistSlice";
import { encodeId, formatDate } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import { getAllCart, postCart } from "../../features/cart/cartSlice";

const Wishlist = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
  const [successmodal, setSuccessmodal] = useState(false);
  const navigate = useNavigate();
  const wishlist = useSelector((state) => state.wishlist.allWishlist);
  const isSignIn = useSelector((state) => state.auth.is_signin);

  useEffect(() => {
    // if (isSignIn) {
    dispatch(getAllWishlist());
    // }
  }, [dispatch]);

  if (!(wishlist.data?.length > 0)) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "40vh" }}
      >
        <div style={{ fontSize: "48px", color: "#ccc" }}>💔</div>
        <h5 style={{ marginTop: "10px", color: "#555", fontWeight: 600 }}>
          No Items in Wishlist
        </h5>
        <p style={{ color: "#777" }}>Start adding your favorite items!</p>
      </div>
    );
  }

  const addToWish = async (productId) => {
    if (!isSignIn) {
      await navigate("/login");
    } else {
      const res = await dispatch(postWishlist({ product_id: productId }));

      console.log("resresresres", res);
      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllWishlist());
      } else if (res.meta?.requestStatus === "rejected") {
      }
    }
  };

  const addToCart = async (product, variant) => {
    try {
      const data = {
        product_id: product?.id,
        variant_id: variant?.id,
        quantity: 1,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
        setSuccessmodal(true);
        setTimeout(() => {
          setSuccessmodal(false);
        }, 2000);
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <section className="Wishlist">
      <Common_breadcrumb
        items={[{ label: "Home", link: "/" }, { label: "Wishlist" }]}
      />

      <div className="container">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table">
              <thead>
                <tr>
                  {/* <th>
                    <Form.Check type="checkbox" />
                  </th> */}
                  <th> Product Info</th>
                  <th>Price</th>
                  <th style={{ width: "200px" }}>Date</th>
                  {/* <th>Stock Status</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {wishlist.data?.map((item, idx) => (
                  <tr key={idx}>
                    {/* <td>
                      <Form.Check type="checkbox" />
                    </td> */}
                    <td>
                      <div className="product_info_cell">
                        <div className="product_img_holder">
                          <img
                            src={
                              process.env.REACT_APP_IMAGE_URL +
                              item.Product?.image
                            }
                            alt={item.Product?.name}
                            className="product_img"
                          />
                        </div>
                        <div className="product_details">
                          <div className="bold_text">{item?.Product?.name}</div>
                          <p className="normal_text">
                            Frame Type –{" "}
                            {item.Product?.Frame_Type?.name || "NA"}
                          </p>
                          <p className="normal_text">
                            Colour – {item.Product?.Colour?.name || "NA"}
                          </p>
                          <p className="normal_text">
                            Size – {item.Product?.Face_Width?.name || "NA"}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="bold_text">{item.Product?.price}</span>
                    </td>
                    <td>{formatDate(item.createdAt)}</td>
                    {/* <td>
                      <span
                        className={
                          item.Product?.Product_Stock
                            ? "green_text"
                            : "red_text"
                        }
                      >
                        {item.Product?.Product_Stock
                          ? "In stock"
                          : "Out of stock"}
                      </span>
                    </td> */}
                    <td >
                      <div className="action_div">
                        <Blue_Round_Btn
                          btnText="Add To Cart"
                          onClick={() => {
                            navigate(
                              `/product-descrption/${encodeId(
                                item.Product?.id
                              )}`
                            );

                            // setSuccessmodal(true);
                            // setTimeout(() => {
                            //   setSuccessmodal(false);
                            // }, 2000);
                          }}
                        />

                        <div className="icon_holder">
                          <FontAwesomeIcon
                            icon={faCircleXmark}
                            className="delete_icon"
                            onClick={() => {
                              addToWish(item?.Product?.id);
                            }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Product Added To Cart"}
      />
    </section>
  );
};

export default Wishlist;
